<template>
  <router-view>
    <template #menuTitle>
      <div class="title">
        <h2>{{$t(menuTitle)}}</h2>
      </div>
    </template>
  </router-view>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["menuTitle"]),
  },
};
</script>